import React from 'react';
import { Box } from '@tanium/react-box';
import { DatePicker } from '@tanium/react-date-picker';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';

interface IDateFilterProps {
  startDate: Moment;
  onStartDateChange: React.Dispatch<React.SetStateAction<Moment>>;
  startMin?: Moment;
  endDate: Moment;
  onEndDateChange: React.Dispatch<React.SetStateAction<Moment>>;
  endMax?: Moment;
}

const DateFilter: React.FC<IDateFilterProps> = ({
  startDate,
  onStartDateChange,
  startMin,
  endDate,
  onEndDateChange,
  endMax,
}) => {
  const { t } = useTranslation();

  return (
    <Box display={'flex'} data-testid="date-filters">
      <Box pr="1">
        <DatePicker
          data-testid="start-date"
          value={startDate.startOf('day').toISOString()}
          minDate={startMin?.toISOString()}
          maxDate={endDate?.startOf('day').toISOString()}
          onChange={({ value }) => onStartDateChange(moment(value).startOf('day'))}
        />
      </Box>
      <Box pt="1" pr="1">
        {t('TO')}
      </Box>
      <Box>
        <DatePicker
          data-testid="end-date"
          value={endDate.endOf('day').toISOString()}
          minDate={startDate.toISOString()}
          maxDate={endMax?.endOf('day').toISOString()}
          onChange={({ value }) => onEndDateChange(moment(value).endOf('day'))}
        />
      </Box>
    </Box>
  );
};

export default DateFilter;
